import { article } from '@stereoagency/sanity-schema';

export const articleByIdQuery = article.schema.builder
  .filter('_id == $id')
  .pick(['_id', 'datetime', 'title', 'introduction', 'content'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies.resolveIn(['_id', 'slug', 'name']).use()
  }))
  .first()
  .use();
